<template>
  <el-main class="main">
    <retouches />
  </el-main>
</template>

<script>
import retouches from '../pub/retouches.vue'
export default {
  name: 'TDretouches',
  components: {
    retouches
  }
}
</script>
